var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Footer/LanguageMenu/LanguageMenuLI.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Menu } from '@wds/menu';
import { Button } from '@wds/button';
import { ButtonGroup } from '@wds/button-group';
import { IconCaretDown } from '@wds/icons';
import { getSiteSupportedLanguages } from '@sm/locale';
import { getLanguageNameFromCode } from '../../../helpers/languageHelpers';
var LanguageMenuLI = function LanguageMenuLI(_ref) {
  var _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? 'en' : _ref$lang;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var orderedLILanguages = getSiteSupportedLanguages().filter(function (language) {
    return language.code !== lang;
  }).sort(function (a, b) {
    var _a$displayOrder, _b$displayOrder;
    return ((_a$displayOrder = a.displayOrder) !== null && _a$displayOrder !== void 0 ? _a$displayOrder : 0) - ((_b$displayOrder = b.displayOrder) !== null && _b$displayOrder !== void 0 ? _b$displayOrder : 0);
  });
  var handleChange = function handleChange() {
    return setShow(function (s) {
      return !s;
    });
  };
  var currentLanguageName = getLanguageNameFromCode(lang);
  var menuTrigger = /*#__PURE__*/React.createElement("div", {
    onChange: handleChange,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: "secondary",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    }
  }, currentLanguageName), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: "secondary",
    label: "Language dropdown",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(IconCaretDown, {
    title: "Language dropdown",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 11
    }
  }))));
  return /*#__PURE__*/React.createElement(Menu, {
    dense: true,
    placement: "top-left",
    show: show,
    menuTrigger: menuTrigger,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 5
    }
  }, orderedLILanguages.map(function (langItem) {
    return /*#__PURE__*/React.createElement(Menu.Item, {
      key: langItem.code,
      isNavigable: true,
      navigationTarget: "/user/language?languageid=".concat(langItem.id, "&ut_source=footer"),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 11
      }
    }, langItem.displayName);
  }));
};
export default LanguageMenuLI;
//# sourceMappingURL=LanguageMenuLI.js.map